import template from "./tariff-form.html";

const TariffFormComponent = {
  bindings: {
    tariff: "<",
    editMode: "<",
    onSave: "&",
    onCancel: "&",
  },
  template: template,
  controller: class TariffFormController {
    /* @ngInject */
    constructor(ModalsManager, $rootScope, Utils, Notification, $filter) {
      this.ModalsManager = ModalsManager;
      this.$rootScope = $rootScope;
      this.Utils = Utils;
      this.NotificationService = Notification;
      this.$filter = $filter;
    }

    $onInit() {
      this.tariff = angular.copy(this.tariff);
      this.saving = false;
      this.currency = this.$rootScope.organization.settings.currency;
      this.rates = this.$rootScope.organization.exchangeRates.rates;
    }

    async save() {
      if (!this.form.$valid) return;
      this.saving = true;
      this.duplicatedDescription = false;
      try {
        await this.tariff.save();
        this.onSave({ tariff: this.tariff });
      } catch (e) {
        if (
          e.status === 400 &&
          e.data.includes("Duplicated tariff description")
        ) {
          this.duplicatedDescription = true;
        }
      } finally {
        this.saving = false;
        this.$rootScope.$applyAsync();
      }
    }

    async addCost() {
      const cost = await this.ModalsManager.openSelectCostModal();
      if (!cost) return;

      this.tariff.addCost(cost);
      this.$rootScope.$applyAsync();
    }

    currencyExchange(currencyFrom, price, quantity) {
      return this.Utils.getCurrencyNumberConverted(
        this.rates,
        currencyFrom,
        this.currency,
        price * (quantity || 0)
      );
    }

    onPriceChange() {
      this.tariff.updateMargin();
    }

    onCostDelete(index) {
      this.tariff.removeCost(index);
    }

    onCostChange() {
      this.tariff.updatePrice();
    }

    onMarginChange() {
      if (this.tariff.costs.length > 0) this.tariff.updatePrice();
    }
  },
};

export default TariffFormComponent;
